module.exports = __webpack_public_path__ + "img/test-card_backup.4c6e772a.png";